module.exports = __webpack_public_path__ + "static/media/icon-diners.8b51c0e2.png";